import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LocaleProvider } from "@/i18n";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { About } from "@/components/About";
import { Ambition } from "@/components/Ambition";
import { PracticeAreas } from "@/components/PracticeAreas";
import { Advocates } from "@/components/Advocates";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { DisclaimerGate } from "@/components/DisclaimerGate";
import Admin from "@/pages/Admin";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Careers from "@/pages/Careers";

const Site = () => {
  useLenis();
  return (
    <>
      <a href="#main" className="skip-link">Skip to content</a>
      <Navbar />
      <main id="main">
        <Hero />
        <TrustStrip />
        <About />
        <Ambition />
        <PracticeAreas />
        <Advocates />
        <Contact />
      </main>
      <Footer />
      <DisclaimerGate />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: { background: "#11182F", color: "#F8F9FA", border: "1px solid rgba(201,154,91,0.4)", borderRadius: 0 },
        }}
      />
    </>
  );
};

function App() {
  return (
    <LocaleProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
      </BrowserRouter>
    </LocaleProvider>
  );
}

export default App;
